module.exports = __webpack_public_path__ + "static/media/19ESCAP13.f231a8ba.jpg";